import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Input,
  InputGroup, InputGroupAddon, InputGroupText,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IVBienTable, IAuthReduxProps, ITarget } from '../../../types/interfaces';

import TableContainer from "../../tables_manager/TableContainer"
import Association from '../../consultation/Association';
import AskDoaModal from '../../consultation/AskDoaModal';
import DivisionModal from '../../consultation/DivisionModal';
import { SelectColumnFilter, NumberRangeColumnFilter } from '../../tables_manager/filters';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGripLines, faArrowRight, faLockOpen, faSpinner, faCheck, faInfoCircle, faClipboard, faCheckCircle, faPhone, faPrint, faIdCard, faEye, faFileInvoice, faCheckSquare, faSquare, faRulerCombined, faMoneyBill, faCommentsDollar, faSyncAlt, faHourglassHalf } from '@fortawesome/free-solid-svg-icons'
import { useAlert } from "react-alert";
import moment from "moment";
import PDFLink from '../../pdf/PDFLink';
import { getVenteByIdPromise } from '../../../flux/actions/venteActions';
import { E_ERROR } from '../../../types/errors';
import { PRIVILEGE } from '../../../types/privileges'
import ReactTooltip from 'react-tooltip';
import { getBienStatut } from '../../../services/misc';

const VBienTable = ({ 
  linesData,
  setSelectedBien,
  isAssociation,
  isFromDT,
  auth
 }: IVBienTable) => {
  const alert = useAlert();

  const [tableData, setTableData] = useState(linesData);
  const [modalAss, setModalAss] = useState(false);
  const [modalAssBien, setModalAssBien] = useState<any>(null);
  const [associationPartInfo, setAssociationPartInfo] = useState<any>('');
  const floors = [{key: 0, display: "RDC"}, {key: 1, display: "1er étage"}, {key: 2, display: "2ème étage"}, {key: 3, display: "3ème étage"}, {key: 4, display: "4ème étage"}];
  const [selectedFloors, setSelectedFloors] = useState<number[]>([]);
  
  const [modalDoa, setModalDoa] = useState(false);
  const [modalDoaBien, setModalDoaBien] = useState<any>(null);
  const [modalDivision, setModalDivision] = useState(false);
  const [modalDivisionBien, setModalDivisionBien] = useState<any>(null);

  useEffect(() => {
    setTableData(isAssociation && selectedFloors.length ? linesData.filter(e => {
      if(!e.contrat)
        return true
      for(let i of selectedFloors)
        if((e.ETAGE_ASS === undefined || Number(e.ETAGE_ASS) >= i + 1) && e.contrat?.associations?.length && (!e.contrat.associations.find(e => e.ETAGE == i) || (e.contrat.associations.find(e => e.ETAGE == i) && e.contrat.associations.reduce((n, t) => {
          return t.POURCENTAGE && t.ETAGE == i ? n + Number(t.POURCENTAGE) : n
        }, 0) < 100)))
          return true
      return false
    }) : linesData);
  }, [linesData, selectedFloors]);

  const viewCard = (e, id) => {
    if(id !== null && id !== undefined)
      window.open('/consultation/' + id, '_blank')
    else
      alert.error(E_ERROR.NO_VENTE_WITH_THIS_ID)
  }

  const toggleSelectedFloor = e => {
    if(selectedFloors.includes(e))
      setSelectedFloors(t => t.filter(n => n !== e))
    else
      setSelectedFloors(t => [...t, e])
  }
  
  const modalClosedHandleAss = () => {
    setAssociationPartInfo('')
  };
  
  const handleToggleAss = () => setModalAss(!modalAss);

  const columns = [
      {
        Header: "Action",
        className: "text-center",
        Cell: ({ row: {original} }) => (
            <Container className="actionsContainer">
                {isAssociation && original.contrat?.associations?.length ? <button className="btn btn-primary btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  onClick={() => (setModalAssBien(original), setModalAss(true))}
                  title="Plus d'informations sur l'association">
                  <FontAwesomeIcon icon={faGripLines} />
                </button> : null}
                {/* {(("DISPONIBLE" === original.STATUT && !isAssociation) || (["DISPONIBLE", "ASSOCIATION OUVERTE"].includes(original.STATUT) && isAssociation)) && ((!isAssociation || (isAssociation && original.ASS === "1")) ? <button className="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  onClick={() => setSelectedBien(original)}
                  // disabled={!}
                  title="Choisir">
                  <FontAwesomeIcon icon={faArrowRight} />
                </button> : isAssociation && original.ASS === "0" ? <button className="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  onClick={() => setModalDoa(true)}
                  title="Ouverture en association">
                  <FontAwesomeIcon icon={faLockOpen} />
                </button> : null)} */}
                {original.contrat?.id ? <PDFLink documentType={"vente"}
                  func={async () => getVenteByIdPromise(original.contrat?.id || -1)}
                  download={false}
                  buttonText=""
                  iconSize="inherit"
                  // customClassNames="btn btn-info"
                  customButtonIcon={faFileInvoice}
                  allowPrintPreview={true}
                  htmlTitle="Voir la fiche de Vente"
                  customClassNames="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  style={{paddingRight: ".75rem", paddingLeft: ".75rem"}} /> : null}
                {original.contrat?.id ? <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  onClick={(e) => viewCard(e, original.contrat?.id)}
                  title="Consultation">
                  <FontAwesomeIcon icon={faEye} />
                </button> : null}
                {((auth?.user?.id === 9 && [13185,13187,13241,13243,13245,13247,13654,13656,13662,13664,14603].includes(original?.id || -1)) || ("DISPONIBLE" === original.STATUT && !isAssociation) || ((("ASSOCIATION OUVERTE" === original.STATUT/* && (original.PROJET!='CM6' || original.TRANCHE != 'T3')*/) || ("DISPONIBLE" === original.STATUT && original.ASS === "1")) && isAssociation)) ? <button className="btn btnB btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                // {(("DISPONIBLE" === original.STATUT && !isAssociation) || (("ASSOCIATION OUVERTE" === original.STATUT || ("DISPONIBLE" === original.STATUT && original.ASS === "1")) && isAssociation)) ? <button className="btn btnB btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  onClick={() => {
                    setSelectedBien(original)
                    if(!isFromDT && original.minEnc){
                      if(original.minEncIsNumber == 1)
                        alert.info("Il va falloir saisir au moins " + Number(original.minEncIsNumber || 0).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + " DH comme avance")
                      else
                        alert.info(`Il va falloir saisir au moins ${Number(original.minEnc || 0)}% du prix du bien`)
                    }
                    // if(!original.allow30){
                    //   if(original.IDPROJET === 15 && original.TYPE === "R+2 Hab")
                    //     alert.info("Il va falloir saisir au moins 100 000 DH comme avance")
                    //   else if(original.IDPROJET === 15 && original.N && Number(original.N || 0) == 1419)
                    //     alert.info("Il va falloir saisir au moins 25% du prix du bien")
                    //   else if((original.IDPROJET === 14 && (original.N == "313" || original.N == "307" || original.N == "282" || original.N == "245" || original.N == "276"))
                    //         || (original.IDPROJET === 15 && original.N && Number(original.N || 0) >= 1417 && Number(original.N || 0) <= 1438)
                    //         || (original.IDPROJET === 16 && (original.TYPE === "R+2 COM" || original.TYPE === "Villa")))
                    //     alert.info("Il va falloir saisir au moins 50% du prix du bien")
                    //   else
                    //     alert.info("Il va falloir saisir au moins 30% du prix du bien")
                    // }
                  }}
                  // disabled={!}
                  title="Choisir">
                  <FontAwesomeIcon icon={faCheck/*faArrowRight*/} />
                </button> : (["DISPONIBLE", "UNIQUE"].includes(original.STATUT) && original.ASS === "0" && isAssociation) ? <>
                  {!original.division || original.division.approved === 0 ? (!!auth?.user?.privileges?.includes(PRIVILEGE.ADD_DIVISION) && <button className="btn btnD btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                    onClick={() => (setModalDivisionBien(original), setModalDivision(true))}
                    title="Répartition Association">
                    <FontAwesomeIcon icon={faLockOpen} />
                  </button>) : <button className="btn btnD btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                    disabled
                    title="Demande déjà envoyée">
                    <FontAwesomeIcon icon={faHourglassHalf} />
                  </button>}
                  {(!original.demande_ouverture_associations?.length || original.demande_ouverture_associations.filter(e => e.approved !== 0).length === 0) ? <button className="btn btn-warning btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                    onClick={() => (setModalDoaBien(original), setModalDoa(true))}
                    disabled={!original.division}
                    title="Ouverture en Association">
                    <FontAwesomeIcon icon={faLockOpen} />
                  </button> : <button className="btn btn-warning btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                    disabled
                    title="Demande déjà envoyée">
                    <FontAwesomeIcon icon={faHourglassHalf} />
                  </button>}
                </> : null}
                {/* </button> : (["DISPONIBLE", "UNIQUE"].includes(original.STATUT) && original.ASS === "0" && isAssociation) ? ((!original.demande_ouverture_associations?.length || original.demande_ouverture_associations.filter(e => e.approved !== 0).length === 0) ? <button className="btn btn-warning btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  onClick={() => (setModalDoaBien(original), setModalDoa(true))}
                  title="Ouverture en association">
                  <FontAwesomeIcon icon={faLockOpen} />
                </button> : <button className="btn btn-warning btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  disabled
                  title="Demande déjà envoyée">
                  <FontAwesomeIcon icon={faHourglassHalf} />
                </button>) : null} */}
            </Container>
        ),
        disableSortBy: true,
      },
      {
        Header: "ID Bien",
        accessor: "id",
        hidden: true
      },
      // {
      //   Header: "Projet",
      //   accessor: "PROJET",
      //   Filter: SelectColumnFilter,
      //   filter: 'equals',
      // },
      {
        Header: "Statut",
        accessor: e => getBienStatut(e.STATUT),
        Filter: SelectColumnFilter,
        filter: 'equals',
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Désignation",
        accessor: "DESIGNATION",
      },
      {
        Header: "N°",
        accessor: "N",
        className: "minTableCellWidth",
        filter: 'equals',
      },
      // {
      //   Header: "Type",
      //   accessor: "TYPE_2",
      //   customExportDisplay: `$.TYPE || "-"`,
      //   Filter: (e) => SelectColumnFilter({...e, capitalizeFirst: true}),
      //   filter: 'equals',
      //   Cell: ({ row }) => row.original.TYPE || "-"
      // },
      {
        Header: "Type",
        accessor: "TYPE",
        customExportDisplay: `$.TYPE || "-"`,
        filter: (rows, id, e) => rows.filter(t => (t.original[id]?.toLowerCase().includes("app") ? "Appartement" : t.original[id]?.toLowerCase().includes("mag") ? "Magasin" : (t.original[id] || "")).toLowerCase().includes(e?.toLowerCase() || "")),
        Cell: ({ row }) => row.original.TYPE?.toLowerCase().includes("app") ? "Appartement" : row.original.TYPE?.toLowerCase().includes("mag") ? "Magasin" : (row.original.TYPE || "-")
      },
      {
        Header: "Tranche",
        accessor: "TRANCHE",
        Filter: SelectColumnFilter,
        filter: 'equals',
        Cell: ({ value }) => value || "-"
      },
      ...(isAssociation ? [] : [{
        Header: "Immeuble",
        accessor: "IMMEUBLE",
        Cell: ({ value }) => !value && value !== "0" ? "-" : value
      }]),
      ...(isAssociation ? [] : [{
        Header: "Étage",
        accessor: "ETAGE",
        // Filter: SelectColumnFilter,
        // filter: 'equals',
        Cell: ({ value }) => !value && value !== "0" ? "-" : value
      }]),
      {
        Header: "Étages",
        accessor: "ETAGE_ASS",
        Filter: SelectColumnFilter,
        filter: 'equals',
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Superficie",
        accessor: "SUPERFICIE",
        Filter: NumberRangeColumnFilter,
        filter: 'between',
      //  Cell: ({ value, row }) => row.original.TYPE_2?.toLowerCase() === "appartement" ? "-" : (value + "m²")
        Cell: ({ value, row }) => (value || 0) + "m²"
      },
      {
        Header: "Prix du M²",
        accessor: "PRIX_M",
        hidden: true,
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        sortType: (a, b, id, desc) => ((a.original[id] !== null && a.original[id] !== undefined && a.original[id] != "") ? Number(a.original[id]) : 0)
                                    > ((b.original[id] !== null && b.original[id] !== undefined && b.original[id] != "") ? Number(b.original[id]) : 0) ? 1 : -1,
        Cell: ({ value }) => (value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
      },
      {
        Header: "Prix du bien",
        accessor: "PRIX_VENTE",
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        sortType: (a, b, id, desc) => ((a.original[id] !== null && a.original[id] !== undefined && a.original[id] != "") ? Number(a.original[id]) : 0)
                                    > ((b.original[id] !== null && b.original[id] !== undefined && b.original[id] != "") ? Number(b.original[id]) : 0) ? 1 : -1,
        Cell: ({ value, row, columns }) => (value !== null && value !== undefined && value != "") || (row.original.PRIX_M !== null && row.original.PRIX_M !== undefined && row.original.PRIX_M != "") ? (<div><div style={{display: "inline-block"}}>{((value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-")}&nbsp;</div><div style={{display: "inline-block"}}>{(!columns.find(e => e.id === "PRIX_M")?.isVisible && (row.original.PRIX_M !== null && row.original.PRIX_M !== undefined && row.original.PRIX_M != "") ? (" (" + ((row.original.PRIX_M.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh")) + "/m²)") : "")}</div></div>) : "-"
      },
      // ...(isAssociation ? [{
      //   Header: "Étages",
      //   disableSortBy: true,
      //   disableFilters: true,
      //   Cell: ({ row: {original} }) => {
      //     if(original.contrat?.associations?.length){
      //       const associationsSorted = original.contrat.associations.sort((a, b) => a.ETAGE - b.ETAGE);
      //       return <div>
      //         {associationsSorted.map((e, key) => <div key={key} style={{width: "100%", border: "1px solid", borderRadius: "5px"}}>
      //           <b>{e.POURCENTAGE}</b>% de l'étage <b>{e.ETAGE}</b> à <b>{(e.PRIX_VENTE !== null && e.PRIX_VENTE !== undefined && e.PRIX_VENTE != "") ? (e.PRIX_VENTE.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}</b>
      //         </div>)}
      //       </div>
      //     }
      //     else
      //       return "-"
      //   }
      // }] : []),
      {
        Header: "Titre foncier",
        accessor: "TF",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
  ];

  return (
    <div>
      {isAssociation ? <Container className="floorsContainer">
        <Row className="justify-content-around">
          {floors.map((e, key) => 
            <Col xs="6" md="2" key={key}>
              <div className={`floorDiv${selectedFloors.includes(e.key) ? " active" : ""}`} onClick={() => toggleSelectedFloor(e.key)}>{e.display}</div>
            </Col>
          )}
        </Row>
      </Container> : null}
      <Container>
        <TableContainer columns={columns} data={tableData} dataName="preparation_vente_bien" enableCheckBox={false} />
      </Container>

      <Modal isOpen={modalAss} toggle={handleToggleAss} onClosed={modalClosedHandleAss} className="modal-dialog-large" style={{minWidth: "900px"}} modalClassName="xOverflowModal">
        <ModalHeader toggle={handleToggleAss}><FontAwesomeIcon icon={faGripLines} />&nbsp;&nbsp;Détails de l'association</ModalHeader>
        <ModalBody>
          <Association associations={modalAssBien?.contrat?.associations} etages={modalAssBien?.ETAGE_ASS} associationPartInfo={associationPartInfo} setAssociationPartInfo={setAssociationPartInfo} division={modalAssBien?.division} isModal />
        </ModalBody>
      </Modal>

      <AskDoaModal modal={modalDoa} setModal={setModalDoa} modalData={modalDoaBien} />
      <DivisionModal modal={modalDivision} setModal={setModalDivision} bien={modalDivisionBien}/* addCallback={e => setDivision(e)}*/ />
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, { })(VBienTable);
